import { render } from "./LolLipop.vue?vue&type=template&id=358b92bc"
const script = {}

import exportComponent from "../../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/package/LolLipop.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "358b92bc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('358b92bc', __exports__)) {
    api.reload('358b92bc', __exports__)
  }
  
  module.hot.accept("./LolLipop.vue?vue&type=template&id=358b92bc", () => {
    api.rerender('358b92bc', render)
  })

}


export default __exports__